// /src/mocks/proyectos.ts
import { IProyecto } from '../types';
import { mockEstandares } from './estandares';

// Función helper para clonar lineamientos de un estándar
const clonarLineamientos = (estandarId: string) => {
  const estandar = mockEstandares.find(e => e.id === estandarId);
  if (!estandar) return [];
  
  const lineamientos = estandar.capitulos.flatMap(cap => 
    cap.lineamientos.map(lin => ({ ...lin, comentarios: [] }))
  );
  
  return lineamientos;
};

export const mockProyectos: IProyecto[] = [
  {
    id: 'proyecto-1',
    empresaClienteId: 'empresa-1',
    estandarId: 'estandar-1',
    nombreEstandar: 'ISO 45001:2018 - Sistema de Gestión de Seguridad y Salud en el Trabajo',
    nombreEmpresa: 'Industrias ABC S.A.S.',
    estadoGeneral: 'En Auditoría',
    lineamientos: clonarLineamientos('estandar-1'),
  },
  {
    id: 'proyecto-2',
    empresaClienteId: 'empresa-2',
    estandarId: 'estandar-2',
    nombreEstandar: 'ISO 9001:2015 - Sistema de Gestión de Calidad',
    nombreEmpresa: 'Comercializadora XYZ Ltda.',
    estadoGeneral: 'Iniciado',
    lineamientos: clonarLineamientos('estandar-2'),
  },
];
